import { render, staticRenderFns } from "./asset-viewer.component.vue?vue&type=template&id=0bad4cfc&"
import script from "./asset-viewer.component.ts?vue&type=script&lang=ts&"
export * from "./asset-viewer.component.ts?vue&type=script&lang=ts&"
import style0 from "./asset-viewer.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports